import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import Swiper from "react-id-swiper";
// import title from '../../static/converted/title_luftaufnahme_wallerwelt-min.jpg'
import logo from "../../static/converted/wallerwelt_logo-min.jpg";

export default class Navigation extends Component {
  render() {
    const params = {
      spaceBetween: 30,
      effect: "fade"
    };

    return (
      <div id="Home">
        <Swiper {...params}>
          <Image src={logo} />
          {/*<Image src={title}/>*/}
        </Swiper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Title/index.js